import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "./CardAvatar.module.scss";

export default function CardAvatar(props) {
  const {
    children,
    className,
    plain,
    profile,
    testimonial,
    testimonialFooter,
    ...rest
  } = props;
  const cardAvatarClasses = classNames(
    styles.cardAvatar,
    {
      [styles.cardAvatarProfile]: profile,
      [styles.cardAvatarPlain]: plain,
      [styles.cardAvatarTestimonial]: testimonial,
      [styles.cardAvatarTestimonialFooter]: testimonialFooter
    },
    className
  );
  return (
    <div className={cardAvatarClasses} {...rest}>
      {children}
    </div>
  );
}

CardAvatar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  profile: PropTypes.bool,
  plain: PropTypes.bool,
  testimonial: PropTypes.bool,
  testimonialFooter: PropTypes.bool
};
